import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { PlacesQuery } from "../../../../../models/PlacesQueryData";
import { ModalConfirm } from "../../../../ModalConfirm";
import { useDeletePlacesQuery } from "../../hooks";

export interface IDeleteQueryModalProps {
  query: PlacesQuery;
  onClose: () => void;
}

export const DeleteQueryModal: React.FunctionComponent<
  IDeleteQueryModalProps
> = ({ query, onClose }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`internalToolsHomePage.gbp_places_query.delete_modal.${key}`);

  const deleteMutation = useDeletePlacesQuery();

  const handleConfirm = async () => {
    await deleteMutation.mutateAsync(query.id);
    toast.success(t("success"));
    onClose();
  };

  return (
    <ModalConfirm
      translate={false}
      title={t("title")}
      description={t("description")}
      cancelLabel={t("cancel")}
      confirmLabel={t("confirm")}
      color="red"
      disableConfirm={deleteMutation.isLoading}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <p>{query.name}</p>
    </ModalConfirm>
  );
};

export default DeleteQueryModal;
